import {Component, ContentChildren, EventEmitter, HostBinding, Input, Output, QueryList, TemplateRef} from '@angular/core';
import {Router} from '@angular/router';
import {ExplorerItem, TreeNodeInfo} from '@catmodules/ui-base/types';
import {NodePathRef} from '@catmodules/widgets/explorer/types';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'tree';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');
const unsetItem: ExplorerItem = {value: null, label: null, expanded: false, allowedActions: []};
const defaultMsgNoItemsFound = 'No items yet.';

const ParamNames = {
  propagatedNodeLevel: 'treeLevel',
};

@Component({
  selector: 'cat-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
})
export class TreeComponent {
  @HostBinding('class') classNames = defaultClassNames;

  @ContentChildren(TemplateRef) innerTemplates: QueryList<any>;

  @Input() items: ExplorerItem[] = [];
  @Input() depthLevel = 0;
  @Input() activeItem: ExplorerItem = unsetItem;
  @Input() noItemsFoundPlaceholder = defaultMsgNoItemsFound;
  @Input() templates: Map<string, any> = new Map();
  @Input() pathToRef: NodePathRef[] = [];
  @Input() customActiveItem = false;
  @Input() doPropagateNodeLevel = true;
  @Input() doCustomNodeAction = false;
  @Input() hoverDivGenerator: (nodeInfo: TreeNodeInfo) => HTMLDivElement | null = null;
  @Output() onActivate = new EventEmitter<TreeNodeInfo>();

  constructor(private router: Router) {
  }

  shouldBeExpanded(item: ExplorerItem) {
    return item.expanded;
  }

  /**
   * Propagate current active item to the next parent level
   * If the origin of the current active item is not on the current level, the original nodeLevel is determined and propagated
   * Also initiate propagating the current node level to the current route as a parameter, if required.
   *
   * @param sourceItem
   */
  onClickItem(sourceItem: TreeNodeInfo) {
    const emitValue = Object.assign(
      {},
      {item: null, nodeLevel: null, params: null},
      sourceItem,
    );

    if (!this.customActiveItem) {
      this.activeItem = emitValue.item;
    }

    if (this.activeItem && !emitValue.processed) {
      emitValue.processed = true;
      emitValue.item.expanded = this.activeItem.children && !this.activeItem.expanded;
    }
    if (this.doPropagateClickEvent(sourceItem)) {
      this.onActivate.emit(emitValue);
    }
  }

  /**
   * Returns true if the current activeItem matches with the provided one
   * @param {ExplorerItem} item
   * @returns {boolean}
   */
  isCurrentActive(item: ExplorerItem) {
    const doEquals = !isNullOrUndefined(this.activeItem) && !isNullOrUndefined(this.activeItem.equals) && this.activeItem.equals(item);
    let isSame = doEquals;
    isSame = isSame || (item === this.activeItem);
    // return isSame;

    return item === this.activeItem;
  }

  pathToNode(index: number) {
    const path = [...this.pathToRef];
    path.push({index});
    return path;
  }

  private doPropagateClickEvent(node: TreeNodeInfo) {
    return !node.isCustom || !this.doCustomNodeAction;
  }

  /**
   * Propagating the current node depth level as QueryParam value to the current router url
   * It can be disabled through the component input doPropagateNodeLevel.
   */
  private initPropagateNodeLevel() {
    if (this.doPropagateNodeLevel) {
      const urlTree = this.router.parseUrl(this.router.url);
      urlTree.queryParams[ParamNames.propagatedNodeLevel] = this.depthLevel.toString();
      this.router.navigateByUrl(urlTree);
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/explorer/components/tree/tree.component.ts